/**
 * 下单区埋点
 */
// 点击上报(币币交易/全仓杠杆/限价单/市价单/条件单/止盈止损/买/卖/市价/限价)
export const SPOT_HOME_ORDER_PLACE = 'SpotHomePageOrderPlace';
// 提交点击（买入/卖出/做多/做空）
export const SPOT_HOME_ORDER_SUBMIT_CLICK = 'SpotHomePageOrderSubmitClick';
// 确认弹层点击（买入/卖出/取消/关闭）
export const SPOT_HOME_ORDER_CONFIRM_CLICK = 'SpotHomePageOrderSubmitConfirmation';
// 下单结果
export const SPOT_HOME_ORDER_SUBMIT_RESULT = 'SpotHomePageOrderSubmitResult';
// 热门币对点击
export const SPOT_HOME_NAVIGATION_BAR_SYMBOL_CLICK = 'SpotHomePageSecondNavigationBarSymbolClick';

export const SPOT_BULLETIN_CLICK = 'SpotBulletinClick';
export const SPOT_PAGE_FORWARDING_CLICK = 'SpotPageForwardingClick';
export const SPOT_PAGE_RECENT_TRADES_CLICK = 'SpotPageRecentTradesClick';
export const SPOT_PAGE_SEARCH_RESULT_CLICK = 'SpotPageSearchResultClick';
export const SPOT_PAGE_CHART_CLICK = 'SpotPageChartClick';
export const SPOT_PAGE_ORDER_BOOK_CLICK = 'SpotPageOrderBookClick';
export const SPOT_PAGE_TRADE_SYMBOL_CLICK = 'SpotPageTradeSymbolClick';
export const SPOT_PAGE_TRADE_SYMBOL_COLLECTION = 'SpotPageTradeSymbolCollection';
export const SPOT_PAGE_SIGN_CLICK = 'SpotPageSigninClick';
export const SPOT_PAGE_ORDER_HISTORY_CLICK = 'SpotPageOrderHistoryClick';
export const SPOT_HOME_PAGE_REPAY_CLICK = 'SpotHomePageRepayClick';
export const SPOT_PAGE_UNPOPULAR_SYMBOL_WARNING_CLICK = 'SpotUnpopularSymbolWarningClick';
export const SPOT_PAGE_ETP_ACCESS_CLICK = 'SpotHomePageETPAccessClick';
export const SPOT_HOME_PAGE_WORDING_HOVER = 'SpotHomePageWordingHover';
export const SPOT_HOME_PAGE_OMINIBUS_ACCICON_CLICK = 'SpotHomePageOminibusAccIconClick';

// 行情导航区
export const SPOT_PAGE_NAVIGATION_HOVER = 'SpotHomePageSecondaryNavigationBarHover';
export const SPOT_PAGE_GUIDE_CLICK = 'SpotHomePageTradingGuideClick';
export const SPOT_PAGE_GUIDE_POPUP_CLICK = 'SpotHomePageSecondaryTradingGuidePopUpClick';

// LaunchPad埋点
export const SPOT_LAUNCHPAD_HOME_REFERRAL_CLICK = 'SpotLpadHomePageReferral';
export const SPOT_LAUNCHPAD_HOME_REFERRAL_COPY = 'SpotLpadHomePageReferralLink';
export const SPOT_LAUNCHPAD_HOME_MAJOR_CLICK = 'SpotLpadHomePageMajorClick';
export const SPOT_LAUNCHPAD_LIST_CLICK = 'SpotLpadListPageClick';
export const SPOT_LAUNCHPAD_DETAIL_CLICK = 'SpotLpadDetailPageClick';
export const SPOT_LAUNCHPAD_DETAIL_REFERRAL_COPY = 'SpotLpadDetailPageReferralLink';
export const SPOT_LAUNCHPAD_DETAIL_ASSET_CLICK = 'SpotLpadDetailPageParticipationClick';
export const SPOT_LAUNCHPAD_DETAIL_MEDIA_CLICK = 'SpotLpadDetailPageMediaAccess';
export const SPOT_LAUNCHPAD_DETAIL_POPUP_CLICK = 'SpotLpadDetailPageSubscriptionPopUpClick';
export const SPOT_LAUNCHPAD_DETAIL_TIP_HOVER = 'SpotLpadDetailPageTipsExposure';
export const SPOT_LAUNCHPAD_DETAIL_ICON_CLICK = 'SpotLpadDetailPageUIIconClick';
export const SPOT_LAUNCHPAD_DETAIL_SUB_ICON_CLICK = 'SpotLpadDetailPageSubscriptionPopUpIconClick';
export const SPOT_LAUNCHPAD_DETAIL_CLACULATOR_CLICK = 'SpotLpadDetailPageCalculatorPopUp';
export const SPOT_LAUNCHPAD_DETAIL_FOOTER_CLICK = 'SpotLpadDetailPageGuiderClick';
export const SPOT_LAUNCHPAD_DETAIL_HEADER_CLICK = 'SpotLpadDetailPageHeaderClick';
export const SPOT_LAUNCHPAD_DETAIL_BUY_CLICK = 'SpotLpadDetailPageBuyInPopUpClick';
export const SPOT_LAUNCHPAD_DETAIL_TRADE_CLICK = 'SpotLpadDetailPageListedSymbolTradeClick';
export const SPOT_LAUNCHPAD_DETAIL_SYMBOL_CLICK = 'SpotLpadDetailPageListedSymbolClick';
export const SPOT_LAUNCHPAD_HOME_HEADER_CLICK = 'SpotLpadHomePageHeadingClick';
export const SPOT_LAUNCHPAD_HOME_FAQ_CLICK = 'SpotLpadHomePageFaQClick';
export const SPOT_LPAD_SHARE_SHOW = 'SpotLpadReferalPopUpExposure';
export const SPOT_LPAD_CENTER_TAB_CLICK = 'SpotLpadUserCenterPageTabClick';
export const SPOT_LPAD_CENTER_CLICK = 'SpotLpadUserCenterPageIconClick';
export const SPOT_LPAD_CENTER_RULE_CLICK = 'SpotLpadUserCenterPageReferralRuleClick';
export const SPOT_LPAD_CENTER_FILTER_CLICK = 'SpotLpadUserCenterPageReferralFilterClick';
export const SPOT_LPAD_CENTER_FILTER_POPUP_CLICK = 'SpotLpadUserCenterPageReferralFilterPopUpClick';
export const SPOT_LPAD_DETAIL_PAGE_KYC_GUIDE_CLICK = 'SpotLpadDetailPageKYCguideClick';
export const SPOT_LPAD_DETAIL_MORETICKET_CLICK = 'SpotLpadDetailPageMoreTicketsPopUpClick';
export const SPOT_LPAD_ASSETS_PAGE_CLICK = 'SpotLpadSnapshotPageClick';

// ETP埋点
export const SPOT_ETP_DECLARATION = 'SpotETPDeclaration';
export const SPOT_ETP_WARNING = 'SpotETPWarning';
export const SPOT_ETP_DECLARATION_PAGE_CLICK = 'SpotETPDeclarationPageClick';
export const SPOT_ETP_S_AND_R_CLICK = 'SpotHomePageETPSAndRClick';
export const SPOT_ETP_S_AND_R_POPUP_CLICK = 'SpotHomePageETPSAndRPopUpClick';
export const SPOT_ETP_DECLARATION_PAGE_BOTTOM_CLICK = 'SpotETPDeclarationPageBottomClick';
export const SPOT_ETP_LEARNING_VIDEO_POPUP = 'SpotETPLandingPageTutorialCall';
export const SPOT_ETP_LEARNING_VIDEO_ACTION = 'SpotETPLearningVideoClick';
export const SPOT_ETP_DECLARATION_PAGE_DROPDOWN_LIST_CLICK = 'SpotETPDeclarationPageDropDownListClick';

// 全仓杠杆埋点
export const SPOT_LEVERAGE_MANUAL_CLICK = 'SpotHomePageMarginManualAndIntroClick';
export const SPOT_LEVERAGE_BUSINESS_CLICK = 'SpotHomePageMarginBusinessClick';
export const SPOT_LEVERAGE_CLOSE_ALERTING_CLICK = 'SpotHomePageCloseMarginAlerting';
export const SPOT_LEVERAGE_ENABLE_ALERTING_CLICK = 'SpotHomePageMarginEnablingAlerting';
export const SPOT_LEVERAGE_TEST_CLICK = 'SpotHomePageMarginTestClick';
export const SPOT_LEVERAGE_BASIC_ACKNOWLEDGEMENT_CLICK = 'SpotHomePageMarginBasisAcknowledgement';
export const SPOT_LEVERAGE_BASIC_POPUP_CLICK = 'SpotHomePageMarginBasisPopUpClick';
export const leverage = {
    outstanding_sub: 'SpotHomePageOrderHistoryRepaymentTickerClick',
    outstanding_repay: 'SpotRepayByTokenClick',
    outstanding_repay_dialog: 'SpotRepayByTokenPopUpAppear',
    outstanding_repay_dialog_btn: 'SpotRepayByTokenPopUpClick',
};
export const SPOT_LEVERAGE_MARGIN_DATA_PAGE_SYMBOL_CLICK = 'SpotMarginDataPageSymbolClick';
export const SPOT_LEVERAGE_MARGIN_DATA_PAGE_TOKEN_CLICK = 'SpotMarginDataPageTokenClick';
export const SPOT_LEVERAGE_MARGIN_DATA_PAGE_VIPTAB_CLICK = 'SpotMarginDataPageVipTabClick';
export const SPOT_LEVERAGE_MARGIN_DISCOUNT_RATE_CLICK = 'SpotHomePageDiscountRateExplanationClick';

// 投票上币
export const vote = {
    home_head: 'VoteForListingHomePgaeHeadingClick',
    home_tip: 'VoteForListingHomePgaeNotesClick',
    home_vote: 'VoteForListingHomePageVotesClick',
    home_history_trade: 'VoteForListingHomePgaePreviousProjectClick',
    home_dialog: 'VoteForListingHomePagePopUpClick',
    detail_btn: 'VoteForListingDetailPageClick',
    detail_dialog: 'VoteForListingDetailPagePopUpClick',
    record_share: 'VoteForListingRecordPageShare',
};

// 创新区埋点
export const SPOT_INNOVATION_ZONE_POPUP_CLICK = 'SpotInnovationZonePopUpClick';
export const SPOT_INNOVATION_ZONE_TAG_HOVER = 'SpotInnovationZoneTagHover';
export const SPOT_INNOVATION_ZONE_INTRODUCTION_CLICK = 'SpotInnovationZoneIntroductionClick';
export const SPOT_AVAILABLE_CREDITS_HOVER = 'SpotAvailableCreditsHover';

// bybit index 埋点
export const spotIndex = {
    time_click: 'SpotIndexPageTimeIntervalSwitch',
    tanking_click: 'SpotIndexPageRankingListClick',
};
// 快捷下单
export const quickOrder = {
    switch: 'SpotHomePageTurnOnQuicklyOrdering',
    buy_sell: 'SpotHomePageKLineQuicklyOrderingClick',
    place_order: 'SpotHomePageOrderKLineOrderBoadSubmitConfirmation',
};

// 质押借贷
export const loanPledge = {
    home: 'SpotLoanRequestPage',
    tab: 'SpotLoanPageHeaderTabAndButtonClick',
    all_order: 'SpotLoanPageHeaderLoanHistoryClick',
    user_manual: 'SpotLoanPageHeaderUserManualClick',
    loan_btn: 'SpotLoanPageBorrowClick',
    kyc_dialog: 'SpotLoanPagePostBorrowingPopUpExposure',
    kyc_dialog_btn: 'SpotLoanPagePostBorrowingPopUpClick',
    account_dialog: 'SpotLoanPagePostKYCPopUpExposure',
    account_dialog_btn: 'SpotLoanPagePostKYCPopUpClick',
    order_search: 'SpotLoanPageOutStandingLoanFilterClick',
    order_list: 'SpotLoanPageOutStandingLoanRecordClick',
    order_page: 'SpotLoanPageSwitchClick',
    faq: 'SpotLoanPageFAQClick',
    loan_dialog: 'SpotLoanPageBorrowingPopUpExposure',
    loan_dialog_btn: 'SpotLoanPageBorrowingPopUpClick',
    loan_result: 'SpotPledgedLoanBorrowingResult',
    repay_dialog: 'SpotPledgedLoanRepayPopUpExposure',
    repay_dialog_btn: 'SpotPledgedLoanRepayPopUpClick',
    repay_dialog_transfer: 'SpotPledgedLoanRepayPopUpTransferClick',
    repay_dialog_deposit: 'SpotPledgedLoanRepayPopUpDepositClick',
    reapy_result: 'SpotPledgedLoanRepayResult',
    pledge_dialog: 'SpotPledgedLoanResetPledgePopUpExposure',
    pledge_dialog_btn: 'SpotPledgedLoanResetPledgePopUpClick',
    pledge_dialog_transfer: 'SpotPledgedLoanResetPledgePopUpTransferClick',
    pledge_dialog_deposit: 'SpotPledgedLoanResetPledgePopUpDepositClick',
    pledge_result: 'SpotPledgedLoanResetPledgeResult',
    reverse_coin: 'SpotLoanPageCoinReverseClick',
    video: 'SpotLoanPageTutorialCall',
    video_btn: 'SpotLoanPageTutorialClick',
};
